import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=2dc51760&scoped=true&"
import script from "./CategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesPage.vue?vue&type=style&index=0&id=2dc51760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc51760",
  null
  
)

export default component.exports